import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts, BlogPost } from '../articles';
import './Blog.css';

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const Blog: React.FC = () => {
  useEffect(() => {
    document.title = 'Blog | Sourov Roy';
  }, []);
  const [selectedLanguages, setSelectedLanguages] = useState<{english: boolean, bengali: boolean}>({
    english: true,
    bengali: true
  });

  const [selectedCategories, setSelectedCategories] = useState<{nature: boolean, technology: boolean, humanities: boolean, business: boolean}>({
    nature: true,
    technology: true,
    humanities: true,
    business: true
  });

  const handleLanguageToggle = (language: 'english' | 'bengali') => {
    setSelectedLanguages(prev => ({
      ...prev,
      [language]: !prev[language]
    }));
  };

  const handleCategoryToggle = (category: 'nature' | 'technology' | 'humanities' | 'business') => {
    setSelectedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  // Filter blog posts based on selected languages and categories
  const filteredBlogPosts = blogPosts.filter((post: BlogPost) => {
    const languageMatch = selectedLanguages[post.language];
    
    // Map article categories to filter categories
    let categoryMatch = false;
    const postCategory = post.category.toLowerCase();
    
    if (postCategory === 'science' && selectedCategories.nature) categoryMatch = true;
    if (postCategory === 'technology' && selectedCategories.technology) categoryMatch = true;
    if ((postCategory === 'philosophy' || postCategory === 'arts') && selectedCategories.humanities) categoryMatch = true;
    if (postCategory === 'business' && selectedCategories.business) categoryMatch = true;
    
    return languageMatch && categoryMatch;
  });

  return (
    <div className="blog">
      <div className="blog-container">
        <div className="blog-header">
          <h2 className="blog-title">My Blogs</h2>
          <div className="filters">
            <div className="language-filter">
              <button 
                className={`filter-btn ${selectedLanguages.english ? 'active' : ''}`}
                onClick={() => handleLanguageToggle('english')}
              >
                English
              </button>
              <button 
                className={`filter-btn ${selectedLanguages.bengali ? 'active' : ''}`}
                onClick={() => handleLanguageToggle('bengali')}
              >
                Bengali
              </button>
            </div>
            <div className="category-filter">
              <button 
                className={`filter-btn ${selectedCategories.nature ? 'active' : ''}`}
                onClick={() => handleCategoryToggle('nature')}
              >
                Nature
              </button>
              <button 
                className={`filter-btn ${selectedCategories.technology ? 'active' : ''}`}
                onClick={() => handleCategoryToggle('technology')}
              >
                Technology
              </button>
              <button 
                className={`filter-btn ${selectedCategories.humanities ? 'active' : ''}`}
                onClick={() => handleCategoryToggle('humanities')}
              >
                Humanities
              </button>
              <button 
                className={`filter-btn ${selectedCategories.business ? 'active' : ''}`}
                onClick={() => handleCategoryToggle('business')}
              >
                Business
              </button>
            </div>
          </div>
        </div>

        {filteredBlogPosts.length > 0 ? (
          <ul className="blog-posts">
            {filteredBlogPosts.map((post: BlogPost) => (
              <li key={post.id} className="blog-post">
                <div className="blog-post-header">
                  <Link to={`/blog/${post.slug}`} className="post-link">
                    {post.title}
                  </Link>
                  <span className="post-date">{formatDate(post.date)}</span>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="no-posts-message">
            <p>No blog posts found for the selected filters.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Blog;
